export const emailSendsKeys = {
	all: ['emailSends'],
	stats: (campaignId) => ['emailSends', 'stats', campaignId],
	sendsByCampaign: (campaignId) => ['emailSends', 'sends', campaignId],
	sends: (campaignId, filters, page, pageSize) => ['emailSends', 'sends', campaignId, filters, page, pageSize],
	blockedRecipients: (campaignId) => ['emailSends', 'blockedRecipients', campaignId],
	customVariables: (campaignId) => ['emailSends', 'customVariables', campaignId],
};

export const emailSendsMutationKeys = {
	exportCsv: ['emailSends', 'exportCsv'],
	rescheduleSkipped: ['emailSends', 'rescheduleSkipped'],
};
